//Resource API state Enums
export const resourcesDispatchConstants = {
  GET_ALL_PLAYLISTS: "GET_ALL_PLAYLISTS",
  ADD_NEW_PLAYLIST: "ADD_NEW_PLAYLIST",
  REMOVE_PLAYLIST: "REMOVE_PLAYLIST",
  GET_A_PLAYLIST: "GET_A_PLAYLIST",
  ADD_TO_PLAYLIST: "ADD_TO_PLAYLIST",
  REMOVE_FROM_PLAYLIST: "REMOVE_FROM_PLAYLIST",
  ADD_TO_HISTORY: "ADD_TO_HISTORY",
  REMOVE_FROM_HISTORY: "REMOVE_FROM_HISTORY",
  CLEAR_HISTORY: "CLEAR_HISTORY",
  ADD_TO_LIKES: "ADD_TO_LIKES",
  REMOVE_FROM_LIKES: "REMOVE_FROM_LIKES",
  ADD_TO_WATCH_LATER: "ADD_TO_WATCH_LATER",
  REMOVE_FROM_WATCH_LATER: "REMOVE_FROM_WATCH_LATER",
};

export const authDispatchConstants = {
  LOGIN:"LOGIN",
  LOGOUT:"LOGOUT"
}

export const USER_TOKEN = "userToken";
